// export var listMockPa = ['120/80','139/85'];
export var listMockPa = ['120/80','139/85','140/95','150/99','160/100','180/110'];

export var listMockWeight = [35,40,45,50,60,65,70,75];

export var listMockHeight = [170,155,120,180,200,195,160,168,165,145];
